/**
 * Welcher Menüpunkt zur aktuellen Adresse gehört — und zwar genau einer.
 *
 * Die Sidebar hob bisher jeden Punkt hervor, dessen Pfad ein Präfix der Adresse
 * ist. Auf ``/testing/testdaten`` leuchteten deshalb „Tickets" **und**
 * „Testdaten", auf ``/abnahme/statistik`` „Abnahme" und „Statistik". Für
 * ``/dashboard`` und ``/system`` gab es dagegen je einen Sonderfall — die sind
 * Präfix von allem und hätten sonst dauerhaft geleuchtet.
 *
 * Statt weiterer Sonderfälle gilt hier: Der **genauere** Menüpunkt gewinnt. Gibt
 * es einen längeren Pfad, der ebenfalls passt, ist der kürzere nicht aktiv.
 */

/** Pfade, die als Abschnitts-Wurzel nur bei genauer Übereinstimmung leuchten. */
const WURZELN = new Set(['/dashboard', '/system']);

function passt(pfad: string, adresse: string): boolean {
  return adresse === pfad || adresse.startsWith(`${pfad}/`);
}

/**
 * @param pfad       Der Pfad des Menüpunkts.
 * @param adresse    Die aktuelle Adresse (``location.pathname``).
 * @param allePfade  Alle Pfade, die im Menü stehen — daran misst sich, ob es
 *                   einen genaueren gibt.
 */
export function istAktiv(pfad: string, adresse: string, allePfade: readonly string[]): boolean {
  // Die Wurzeln sind Präfix von allem; sie leuchten nur, wenn man wirklich dort
  // steht. Eine Unterseite ohne eigenen Menüpunkt (etwa ``/dashboard/search``)
  // hebt deshalb gar nichts hervor — das war schon vorher so.
  if (WURZELN.has(pfad)) return adresse === pfad;
  if (!passt(pfad, adresse)) return false;
  return !allePfade.some(
    (anderer) => anderer.length > pfad.length && !WURZELN.has(anderer) && passt(anderer, adresse)
  );
}
